import { getCountryCodes, getStateProvinceCodes } from 'controllers/fedEx'
import { FedExCountryCodeDto, FedExUSStateCodeDto } from 'dtos/fedEx'
import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'

export const FedExAddressContext = createContext<{
  countryCodes: FedExCountryCodeDto[]
  isLoadingCountryCodes: boolean
  isLoadingStateProvinceCodes: boolean
  stateProvinceCodes: FedExUSStateCodeDto[]
} | null>(null)

// TODO: Explain me
export default function FedExAddressProvider({ children }: React.PropsWithChildren) {
  const { status: authStatus } = useAuth()

  const [countryCodes, setCountryCodes] = useState<FedExCountryCodeDto[]>([])
  const [isLoadingCountryCodes, setIsLoadingCountryCodes] = useState<boolean>(false)
  const [isLoadingStateProvinceCodes, setIsLoadingStateProvinceCodes] = useState<boolean>(false)
  const [stateProvinceCodes, setStateProvinceCodes] = useState<FedExUSStateCodeDto[]>([])

  useEffect(() => {
    if (authStatus === 'authorized') {
      setIsLoadingCountryCodes(true)
      getCountryCodes()
        .then(res => {
          setCountryCodes(res.value)
        })
        .finally(() => setIsLoadingCountryCodes(false))

      setIsLoadingStateProvinceCodes(true)
      getStateProvinceCodes()
        .then(res => {
          setStateProvinceCodes(res.value)
        })
        .finally(() => setIsLoadingStateProvinceCodes(false))
    }
  }, [authStatus])

  return (
    <FedExAddressContext.Provider
      value={{
        countryCodes,
        isLoadingCountryCodes,
        isLoadingStateProvinceCodes,
        stateProvinceCodes
      }}
    >
      {children}
    </FedExAddressContext.Provider>
  )
}

export const useFedExAddresses = () => useContext(FedExAddressContext)!
